import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  CANCEL_LABEL,
  FOLLOW_DEFAULTS_LABEL,
  OVERRIDE_ALL_LABEL,
  type ConflictCopy,
} from '@/lib/designations/organisationDefaults';
import './variantMappingDesign.css';

interface ConflictResolutionDialogProps {
  open: boolean;
  copy: ConflictCopy | null;
  onCancel: () => void;
  onFollowDefaults: () => void;
  onOverrideAll: () => void;
}

const ConflictResolutionDialog = ({
  open,
  copy,
  onCancel,
  onFollowDefaults,
  onOverrideAll,
}: ConflictResolutionDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onCancel(); }}>
      <DialogContent data-testid="conflict-resolution-dialog" className="vm-design__conflict">
        <DialogHeader className="vm-design__conflict-head">
          <div className="vm-design__conflict-mark" aria-hidden>!</div>
          <div>
            <DialogTitle className="vm-design__conflict-title">{copy?.title}</DialogTitle>
            <DialogDescription className="vm-design__conflict-body">{copy?.body}</DialogDescription>
          </div>
        </DialogHeader>
        <div className="vm-design__conflict-options">
          <button type="button" className="vm-design__conflict-option" onClick={onFollowDefaults} data-testid="conflict-follow-defaults">
            <strong>{FOLLOW_DEFAULTS_LABEL}</strong>
            <span>{copy?.followDefaultsDescription}</span>
          </button>
          <button type="button" className="vm-design__conflict-option vm-design__conflict-option--danger" onClick={onOverrideAll} data-testid="conflict-override-all">
            <strong>{OVERRIDE_ALL_LABEL}</strong>
            <span>{copy?.overrideAllDescription}</span>
          </button>
        </div>
        <div className="vm-design__conflict-foot">
          <button type="button" className="vm-design__picker-done" onClick={onCancel} data-testid="conflict-cancel">
            {CANCEL_LABEL}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConflictResolutionDialog;
